import gsap from "gsap";
import EventBus from "@lib/helpers/event-bus";

export default () => {
  gsap.ticker.add(() => {
    EventBus.emit("tick");
  });
};



// WEBPACK FOOTER //
// ./scripts/lib/plugins/ticker.js